// extracted by mini-css-extract-plugin
export default {"tbody":"update-form-list_tbody__o7LLV"};